if (!customElements.get('jobski-newsletter-popup')) {
  customElements.define('jobski-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      const key = 'jobski_newsletter_dismissed';
      const mark = () => { try { localStorage.setItem(key, String(Date.now())); } catch (_) {} };
      this.querySelector('[data-popup-open]').addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-popup-close]').addEventListener('click', () => { mark(); this.dialog.close(); });
      this.dialog.addEventListener('cancel', mark);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const box = this.dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) { mark(); this.dialog.close(); } } });
      if (this.querySelector('[data-popup-success],[data-popup-error]')) { this.dialog.showModal(); mark(); return; }
      let last = 0; try { last = Number(localStorage.getItem(key) || 0); } catch (_) {}
      if (Date.now() - last > 7 * 86400000 && !location.pathname.includes('/cart')) {
        this.timer = setTimeout(() => { if (!document.hidden && !document.querySelector('dialog[open],cart-drawer.active,input:focus,textarea:focus,jobski-scent-finder[data-engaged]') && !document.querySelector('#jobski-promo-message:not([hidden])')) this.dialog.showModal(); }, 15000);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}
